
  import * as ipxRuntime$obbM4OGd5FdBhCU5L_deoID3vNDJPY5y9lMTfUbi_zI from '/build_dir/node_modules/@nuxt/image/dist/runtime/providers/ipx'
  
  export const imageOptions = {
    ...{
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {},
  "provider": "ipx",
  "domains": [],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp",
    "webp"
  ]
},
    providers: {
        ['ipx']: { provider: ipxRuntime$obbM4OGd5FdBhCU5L_deoID3vNDJPY5y9lMTfUbi_zI, defaults: {} }
    }
  }
